import React from 'react';
import { Components } from '../../common/interfaces';
import { getErrorMessage } from '../../utils/ErrorUtil';
import { parseMarkedDownText } from '../../utils/ContentUtil';
import { parseTaxInfoContent } from './helper';
import { TaxContainer } from './styled';
import { Strings } from './strings';
var Tax = function Tax(_ref) {
  var content = _ref.content,
    onError = _ref.onError,
    price = _ref.price,
    basePrice = _ref.basePrice,
    discountedTaxInfo = _ref.discountedTaxInfo;
  if (!content) return null;
  if (!content.taxInfo) {
    onError(getErrorMessage(Components.TAX, "".concat(Strings.MISSING_CONTENT_ERROR)));
    return null;
  }
  var taxInfo = content.taxInfo;
  var parsedTaxInfoContent = parseTaxInfoContent(discountedTaxInfo || taxInfo, price, basePrice);
  var taxHtml = parseMarkedDownText(parsedTaxInfoContent);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TaxContainer, null, /*#__PURE__*/React.createElement("div", {
    "data-test": 'TAX_INFO',
    dangerouslySetInnerHTML: taxHtml
  })));
};
export default /*#__PURE__*/React.memo(Tax);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/Tax/index.js
// module id = 4015
// module chunks = 11